<template>
  <div>
    <Modal v-model="reNameModal" title="重命名函数" @on-cancel="newName = ''; oldName = ''">
      <Alert show-icon>正在重命名函数「{{ oldName }}」</Alert>
      新函数名：<Input v-model="newName" placeholder="请输入新的函数名称" />
      <div slot="footer">
        <Button type="primary" @click="reNameOk" :loading="reNaming">提交</Button>
        <Button @click="reNameModal = false" style="margin-left: 8px">取消</Button>
      </div>
    </Modal>
    <Row>
      <div v-for="(item, index) in data" :key="index" style="padding-left: 10px; display:block; width: 350px; float: left; line-height: 25px;">
        <Dropdown trigger="contextMenu" @on-click="v=>{ clickTools(v, item)}" transfer :class="{ 'table-list-item': true, 'table-list-item-active': item === selectd }">
          <span v-on:dblclick="modifyFunc(item)" v-on:click="select(item)">
            <span><font-awesome-icon icon="superscript" style="color: #2d8cf0" /></span>
            <span style="padding-left: 5px">{{ item }}</span>
          </span>
          <DropdownMenu slot="list">
            <DropdownItem name="create">新建函数</DropdownItem>
            <DropdownItem name="modify">编辑函数</DropdownItem>
            <DropdownItem name="reName" :disabled="reNaming">重命名</DropdownItem>
            <DropdownItem name="delete" :style="{ color: deleting ? '' : 'red' }" :disabled="deleting">删除函数</DropdownItem>
            <DropdownItem name="refresh">刷新</DropdownItem>
          </DropdownMenu>
        </Dropdown>
      </div>
    </Row>
    <Row style="margin-top: 30px">
      <SQLResults ref="SQLResults" :callbackdata="callbackdata" :log="false"></SQLResults>
    </Row>
  </div>
</template>

<script>
import { showFuncList, executeSQL } from '@/api/mysql'
import SQLResults from './sqlResults'
export default {
  name: 'dbFuncList',
  components: {
    SQLResults
  },
  data () {
    return {
      data: [],
      getDataIng: false,
      selectd: '',
      deleting: false,
      // 重命名
      reNameModal: false,
      oldName: '',
      newName: '',
      reNaming: false
    }
  },
  props: {
    callbackdata: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  mounted () {
    this.getListData()
  },
  methods: {
    getListData () {
      this.getDataIng = true
      let params = {
        db: this.callbackdata.db,
        id: this.callbackdata.instance_id
      }
      showFuncList(params).then(res => {
        this.getDataIng = false
        this.selectd = ''
        this.data = res.data.results
      }).catch(res => {
        this.getDataIng = false
      })
    },
    // 编辑函数
    modifyFunc (name) {
      let data = {
        func: name,
        db: this.callbackdata.db
      }
      this.$emit('callBack', 'modifyFunc', data)
    },
    // 右键触发下拉工具
    clickTools (type, name) {
      switch (type) {
        case 'create':
          this.$emit('callBack', 'createFunc', this.callbackdata)
          break
        case 'delete':
          this.deleteFunc(name)
          break
        case 'reName':
          this.openReNameModal(name)
          break
        case 'modify':
          this.modifyFunc(name)
          break
        case 'refresh':
          this.getListData()
          break
      }
    },
    // 选中/取消选中 表
    select (name) {
      if (this.selectd === name) {
        this.selectd = ''
      } else {
        this.selectd = name
      }
    },
    // 打开重命名模态框
    openReNameModal (name) {
      this.oldName = name
      this.reNameModal = true
    },
    // 重命名函数
    reNameOk () {
      if (!this.newName) {
        this.$Notice.error({
          title: '函数名不能为空'
        })
        return false
      }
      let sql = 'UPDATE mysql.proc SET name=\'' + this.newName + '\', specific_name=\'' + this.newName + '\' ' +
        'WHERE db=\'' + this.callbackdata.db + '\' AND name=\'' + this.oldName + '\';'
      sql += 'UPDATE mysql.procs_priv SET routine_name=\'' + this.newName + '\' WHERE db=\'' + this.callbackdata.db +
        '\' AND routine_name=\'' + this.oldName + '\'; FLUSH PRIVILEGES;'
      this.reNaming = true
      this.execSQLAction(sql, 'reName')
    },
    // 删除函数
    deleteFunc (name) {
      if (this.deleting) {
        return false
      }
      this.$Modal.confirm({
        title: '确认删除函数「' + name + '」吗？',
        onOk: () => {
          this.deleting = true
          let sql = 'DROP FUNCTION ' + name + ';'
          this.execSQLAction(sql, 'delete')
        }
      })
    },
    // 执行SQL动作
    execSQLAction (sql, type) {
      let data = {
        id: this.callbackdata.instance_id,
        db: this.callbackdata.db,
        sql: sql,
        limit: 100
      }
      executeSQL(data).then(res => {
        let results = []
        res.data.results.forEach(function (item, index) {
          results.push({'id': index + 1, 'res': item['data'], 'columns': [], 'msg': item['msg']})
          let cols = Object.keys(item['data'][0])
          if (cols) {
            cols.forEach(function (row) {
              results[index].columns.push({'title': row, 'key': row, 'minWidth': 130})
            })
          }
        })
        this.$refs.SQLResults.showResult(results)
        switch (type) {
          case 'delete': {
            this.deleting = false
            this.getListData(this.callbackdata)
            break
          }
          case 'reName': {
            this.reNaming = false
            this.reNameModal = false
            this.newName = ''
            this.getListData(this.callbackdata)
          }
        }
      }).catch(res => {
        switch (type) {
          case 'delete': {
            this.deleting = false
            this.getListData(this.callbackdata)
            break
          }
          case 'reName': {
            this.reNaming = false
            this.getListData(this.callbackdata)
          }
        }
        if (res.request) {
          this.$Notice.error({
            title: '操作失败！请求状态码:' + res.request.status,
            desc: res.request.response
          })
        } else {
          this.$Notice.error({
            title: '操作失败！服务器无响应'
          })
        }
      })
    }
  }
}
</script>

<style scoped>
  .table-list-item:hover, .table-list-item:visited {
    color: #2d8cf0;
    cursor:pointer;
  }
  .table-list-item-active {
    background-color: rgb(243, 243, 243);
    color: #2d8cf0;
  }
</style>
